import moment from "moment";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { fullname, getInitials, getModelTypeLabel } from "~/lib/utils";
import { modelActions } from "~/redux/slice/models";
import { useSelector } from "~/redux/store";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Icon,
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
  Separator,
  ToolTipEllipsis,
} from "../ui";

const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(
    (state) => state.persistedReducer.models.notifications,
  );
  return (
    <Popover>
      <PopoverTrigger className="relative">
        <div className="relative">
          {notifications && notifications?.length > 0 && (
            <div className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-danger-500 font-Medium text-[8px] text-white">
              {notifications?.length}
            </div>
          )}
          <Icon name="Bell" className="size-6" />
        </div>
      </PopoverTrigger>
      <PopoverContent
        onWheel={(event) => event.stopPropagation()}
        align="end"
        className="w-[28rem]"
      >
        <div className="">
          <div className="flex items-center justify-between gap-4">
            <span className="font-Medium text-2xl">Notifications</span>
            <PopoverClose>
              <div className="flex size-12 items-center justify-center rounded-full bg-neutral-100">
                <Icon name="X" />
              </div>
            </PopoverClose>
          </div>

          <div className="w-full">
            <div className="max-h-[395px] w-full overflow-y-auto py-5">
              {(!notifications || notifications?.length === 0) && (
                <div className="flex items-center justify-center">
                  <span className="text-lg font-semibold text-neutral-600">
                    No notifications
                  </span>
                </div>
              )}
              <ul className="w-full space-y-3">
                {notifications?.map((item, idx) => (
                  <Fragment key={idx}>
                    <li
                      className="hover:cursor-pointer"
                      onClick={() =>
                        dispatch(modelActions.removeNotification(item.id))
                      }
                    >
                      <div className="space-y-3 px-2 py-2">
                        <div className="flex items-center justify-start gap-2">
                          <Icon
                            name="ShieldAlert"
                            className="size-5 text-neutral-600"
                          />
                          <span className="text-sm text-neutral-600">
                            {getModelTypeLabel(item?.modelType)}
                          </span>
                        </div>
                        <div className="flex gap-4">
                          <Avatar className="cursor-pointer bg-neutral-100">
                            <AvatarImage
                              src={item?.createdBy?.avatar?.toString()}
                              alt="avator"
                            />
                            <AvatarFallback className="bg-secondary-500 text-primary-500">
                              {getInitials(
                                fullname(
                                  item?.createdBy?.firstName,
                                  item?.createdBy?.lastName,
                                ),
                              )}
                            </AvatarFallback>
                          </Avatar>

                          <div className="space-y-3">
                            <div className="flex items-center gap-2 text-sm">
                              <ToolTipEllipsis
                                title={fullname(
                                  item?.createdBy?.firstName,
                                  item?.createdBy?.lastName,
                                )}
                                className="max-[25ch] font-Bold"
                              />
                              <span>assigned you to an</span>
                              <span className="font-Bold">
                                {getModelTypeLabel(item?.modelType)}
                              </span>
                            </div>
                            <div className="rounded-md border border-neutral-300 px-4 py-2">
                              <ToolTipEllipsis
                                title={item?.title}
                                className="max-w-full text-sm"
                              />
                            </div>
                            <div className="flex items-center justify-between gap-2 text-xs text-neutral-500">
                              <span>
                                Due:{" "}
                                {moment(item?.dueDate, "YYYYMMDD").fromNow()}
                                {/* {moment(item?.dueDate).format("LL")} */}
                              </span>
                              <span>{moment(item?.createdAt).calendar()}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    {notifications?.length - 1 !== idx && (
                      <Separator className="bg-neutral-200" />
                    )}
                  </Fragment>
                ))}
              </ul>
            </div>
            <Separator className="bg-neutral-200" />
            <div
              className="flex items-center gap-4 px-4 py-2 hover:cursor-pointer"
              onClick={() => {
                dispatch(modelActions.clearNotifications());
              }}
            >
              <Icon name="Check" />
              <span>Mark all as read</span>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Notifications;
